export default __webpack_public_path__ + "dfb9dd4b46bf6031665e367b9ebb0a2e.jpg";